let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9mHJa")).then(() => parcelRequire('2epAO'));